import Vue from 'vue'
import Router from 'vue-router'
import NoFoundPage from '@/pages/404'
import home from '@/pages/home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '404',
      component: NoFoundPage
    },
    {
      path: '/home',
      name: 'home',
      component: home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js